import { Constants } from "../constants";
export default {
  setAlarmsRaisedList(payload: any) {
    return {
      payload,
      type: Constants.SET_RAISED_ALARM_LIST,
    };
  },
  setAlarmsSolvedList(payload: any) {
    return {
      payload,
      type: Constants.SET_SOLVED_LIST,
    };
  },
  setAlarmsRaisedCount(payload: any) {
    return {
      payload,
      type: Constants.SET_RAISED_ALARM_COUNT,
    };
  },
  setAlarmsSolvedCount(payload: any) {
    return {
      payload,
      type: Constants.SET_SOLVED_COUNT,
    };
  },
  filterLocationReference(payload: any) {
    return {
      payload,
      type: Constants.SET_ALARM_LOCATION_REFERENCE_FILTER,
    };
  },
};
